export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** Buffer scalar type */
  Buffer: any;
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: any;
};

export type AiOutputConfig = {
  __typename?: 'AIOutputConfig';
  enabled: Scalars['Boolean'];
  outputFilenameTemplate?: Maybe<Scalars['String']>;
  prompt?: Maybe<Scalars['String']>;
};

export type Account = {
  __typename?: 'Account';
  _id: Scalars['String'];
  active: Scalars['Boolean'];
  avatarFileId?: Maybe<Scalars['String']>;
  contactInfo?: Maybe<ContactInfo>;
  establishment?: Maybe<Etablissement>;
  groups?: Maybe<Array<Scalars['String']>>;
  licenses: Array<Scalars['String']>;
  medconnectAgentConfig?: Maybe<MedconnectAgentConfig>;
  policies: Array<Scalars['String']>;
  roles: Array<Role>;
  subscription: SubscriptionType;
  type: KeycloakUserType;
  userInfo: UserInfo;
};

export type Address = {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  placeId: Scalars['String'];
  postalCode?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
};

export type Admin = {
  __typename?: 'Admin';
  _id: Scalars['String'];
  active: Scalars['Boolean'];
  avatarFileId?: Maybe<Scalars['String']>;
  contactInfo?: Maybe<ContactInfo>;
  email: Scalars['String'];
  emailStatistics?: Maybe<Array<Scalars['String']>>;
  establishment?: Maybe<Etablissement>;
  licenses: Array<Scalars['String']>;
  permissions: Array<Permission>;
  policies: Array<Scalars['String']>;
  roles: Array<Role>;
  subscription: SubscriptionType;
  type: KeycloakUserType;
  userInfo: UserInfo;
};

export type AttendingPhysician = {
  __typename?: 'AttendingPhysician';
  city?: Maybe<Scalars['String']>;
  cp?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstname: Scalars['String'];
  gender?: Maybe<Scalars['String']>;
  lastname: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  pluginId?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
};

export enum AvailabilityMeetingPlace {
  AtHome = 'AT_HOME',
  Center = 'CENTER',
  SecondOpinion = 'SECOND_OPINION',
  VisioConference = 'VISIO_CONFERENCE'
}

export enum BillingIssueReason {
  DesmosDown = 'DesmosDown',
  MissingInfo = 'MissingInfo',
  NoSocialSecurity = 'NoSocialSecurity',
  Other = 'Other',
  PatientRefused = 'PatientRefused',
  TechnicalIssue = 'TechnicalIssue'
}

export type BillingReview = {
  __typename?: 'BillingReview';
  issueReason?: Maybe<BillingIssueReason>;
  justificationFileKeys: Array<Maybe<Scalars['String']>>;
  note?: Maybe<Scalars['String']>;
  reviewedAt?: Maybe<Scalars['DateTime']>;
  status: BillingReviewStatus;
};

export enum BillingReviewStatus {
  Completed = 'Completed',
  Issue = 'Issue',
  Pending = 'Pending'
}

export type Biological = {
  __typename?: 'Biological';
  comment: Scalars['String'];
  /** @deprecated deprecated */
  file?: Maybe<Scalars['String']>;
  files: Array<Scalars['String']>;
  id: Scalars['String'];
  label: Scalars['String'];
  unit: Scalars['String'];
  value: Scalars['String'];
};

export enum Channel {
  Email = 'EMAIL',
  Push = 'PUSH',
  Sms = 'SMS'
}

export type ChatRoom = {
  __typename?: 'ChatRoom';
  _id: Scalars['String'];
  createdBy: Staff;
  isPrivate: Scalars['Boolean'];
  messages: Array<Message>;
  name: Scalars['String'];
  network?: Maybe<Network>;
  users: Array<Staff>;
};

export type ChimeAttendeeInfo = {
  __typename?: 'ChimeAttendeeInfo';
  AttendeeId: Scalars['String'];
  ExternalUserId?: Maybe<Scalars['String']>;
  JoinToken: Scalars['String'];
};

export type ChimeMediaPlacement = {
  __typename?: 'ChimeMediaPlacement';
  AudioFallbackUrl?: Maybe<Scalars['String']>;
  AudioHostUrl?: Maybe<Scalars['String']>;
  EventIngestionUrl?: Maybe<Scalars['String']>;
  ScreenDataUrl?: Maybe<Scalars['String']>;
  ScreenSharingUrl?: Maybe<Scalars['String']>;
  ScreenViewingUrl?: Maybe<Scalars['String']>;
  SignalingUrl?: Maybe<Scalars['String']>;
  TurnControlUrl?: Maybe<Scalars['String']>;
};

export type ChimeMeeting = {
  __typename?: 'ChimeMeeting';
  attendeeInfo: ChimeAttendeeInfo;
  meetingInfo: ChimeMeetingInfo;
};

export type ChimeMeetingInfo = {
  __typename?: 'ChimeMeetingInfo';
  MediaPlacement: ChimeMediaPlacement;
  MediaRegion?: Maybe<Scalars['String']>;
  MeetingId: Scalars['String'];
};

export enum Civility {
  Dr = 'DR',
  Mme = 'MME',
  Mr = 'MR',
  Pr = 'PR'
}

export type CompanionInput = {
  confidentialityAgreement: Scalars['Boolean'];
  email?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  relationshipType: Scalars['String'];
  relationshipTypeDisplay?: InputMaybe<Scalars['String']>;
};

export type Consultation = {
  __typename?: 'Consultation';
  _id: Scalars['String'];
  autoFSPDocument?: Maybe<ConsultationFile>;
  autoRecording?: Maybe<Scalars['Boolean']>;
  billingReview?: Maybe<BillingReview>;
  biologicals?: Maybe<Array<Biological>>;
  commentaire?: Maybe<Scalars['String']>;
  createdBy: Staff;
  desmosActStatus?: Maybe<DesmosActStatus>;
  devicesUsed: Array<ConsultationDeviceUsage>;
  dictaphones?: Maybe<Array<DictaphoneFile>>;
  endDate?: Maybe<Scalars['DateTime']>;
  establishment?: Maybe<Etablissement>;
  expectedDuration?: Maybe<Scalars['Float']>;
  files: Array<ConsultationFile>;
  formSubmissions?: Maybe<Array<FormSubmission>>;
  groupId?: Maybe<Scalars['String']>;
  guest?: Maybe<Staff>;
  medecin?: Maybe<Staff>;
  mesures: Array<ConsultationMesure>;
  notification?: Maybe<Scalars['Float']>;
  paid?: Maybe<Scalars['Boolean']>;
  patient?: Maybe<Patient>;
  patientConsent?: Maybe<PatientConsent>;
  patientLocation?: Maybe<MeetingPlace>;
  paymentType?: Maybe<PaymentType>;
  payment_Session_id?: Maybe<Scalars['String']>;
  pds?: Maybe<Staff>;
  pi?: Maybe<Scalars['String']>;
  pluginId?: Maybe<Scalars['String']>;
  pregnancy?: Maybe<Pregnancy>;
  prescriptions?: Maybe<Array<OrdoclicPrescription>>;
  price?: Maybe<Scalars['Float']>;
  professionalConsent?: Maybe<ProfessionalConsent>;
  rating?: Maybe<Scalars['Float']>;
  readiness?: Maybe<ConsultationReadiness>;
  reason?: Maybe<Scalars['String']>;
  receiptUrl?: Maybe<Scalars['String']>;
  recordingConsentPending?: Maybe<Scalars['Boolean']>;
  report?: Maybe<Report>;
  shutdown?: Maybe<Scalars['Boolean']>;
  sixHourReminderSent?: Maybe<Scalars['Boolean']>;
  slot: Scalars['String'];
  speciality?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  status: ConsultationStatus;
  steto?: Maybe<ConsultationFile>;
  transcription?: Maybe<Transcription>;
  twentyFourHourReminderSent?: Maybe<Scalars['Boolean']>;
  type: ConsultationType;
  validatedAt?: Maybe<Scalars['DateTime']>;
  waitingRoom?: Maybe<Scalars['String']>;
  waitingRoomJoinedAt?: Maybe<Scalars['DateTime']>;
};

/**
 * Trace of an exam device (stethoscope, medical camera) being activated during
 * the consultation. Written by POST /consultations/:id/device-usage; proves the
 * device was used even when no capture or recording was archived.
 */
export type ConsultationDeviceUsage = {
  __typename?: 'ConsultationDeviceUsage';
  activatedAt: Scalars['DateTime'];
  customName?: Maybe<Scalars['String']>;
  deviceLabel?: Maybe<Scalars['String']>;
  deviceType: Scalars['String'];
  trigger: DeviceUsageTrigger;
};

export type ConsultationFile = {
  __typename?: 'ConsultationFile';
  filename: Scalars['String'];
  isBillingJustification?: Maybe<Scalars['Boolean']>;
  isRecording?: Maybe<Scalars['Boolean']>;
  key: Scalars['String'];
  objectType?: Maybe<Scalars['String']>;
  recordingAnnotations: Array<Maybe<RecordingAnnotation>>;
  uploadedBy?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type ConsultationMesure = {
  __typename?: 'ConsultationMesure';
  label: Scalars['String'];
  order: Scalars['Float'];
  unit: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type ConsultationReadiness = {
  __typename?: 'ConsultationReadiness';
  note?: Maybe<Scalars['String']>;
  readyAt?: Maybe<Scalars['DateTime']>;
  status: ConsultationReadinessStatus;
};

export enum ConsultationReadinessStatus {
  Preparing = 'Preparing',
  Ready = 'Ready'
}

export enum ConsultationStatus {
  Accepted = 'Accepted',
  Active = 'Active',
  Canceled = 'Canceled',
  Completed = 'Completed',
  Refused = 'Refused',
  Scheduled = 'Scheduled'
}

export enum ConsultationType {
  Classic = 'Classic',
  Emergency = 'Emergency',
  Local = 'Local',
  MeetingOnly = 'MeetingOnly',
  Netsoins = 'Netsoins',
  Pedcl = 'Pedcl'
}

export type Contact = {
  __typename?: 'Contact';
  contact?: Maybe<Scalars['String']>;
  requestBy?: Maybe<Scalars['String']>;
  status: Scalars['String'];
};

export type ContactInfo = {
  __typename?: 'ContactInfo';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  cp?: Maybe<Scalars['Int']>;
  phone?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
};

export type Coordinates = {
  __typename?: 'Coordinates';
  lat: Scalars['Float'];
  lng: Scalars['Float'];
};

export type CoordinatesInput = {
  lat: Scalars['Float'];
  lng: Scalars['Float'];
};

export type CreateAttendingPhysicianInput = {
  city?: InputMaybe<Scalars['String']>;
  cp?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstname: Scalars['String'];
  gender?: InputMaybe<Scalars['String']>;
  lastname: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
};

export type CreateFormSubmissionInput = {
  consultation?: InputMaybe<Scalars['String']>;
  expertise?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['String']>;
  patient: Scalars['String'];
  responses: Array<FormResponseInput>;
  status: FormSubmissionStatus;
  tags?: InputMaybe<Array<Scalars['String']>>;
  template: Scalars['String'];
};

export type CreateImcInput = {
  indice: Scalars['String'];
  value: Scalars['Float'];
};

export type CreateOrderInput = {
  comment?: InputMaybe<Scalars['String']>;
  companion?: InputMaybe<CompanionInput>;
  files?: InputMaybe<Array<OrderFileInput>>;
  formSubmission?: InputMaybe<Scalars['String']>;
  isImmediate?: InputMaybe<Scalars['Boolean']>;
  meetingLink: Scalars['String'];
  meetingPlace: OrderMeetingPlaceInput;
  patientConsent?: InputMaybe<OrderPatientConsentInput>;
  patientInfo: OrderPatientInfoInput;
  speciality: Scalars['String'];
  startDate: Scalars['String'];
  status?: InputMaybe<Scalars['String']>;
};

export type CreateParentInput = {
  city?: InputMaybe<Scalars['String']>;
  cp?: InputMaybe<Scalars['Int']>;
  email?: InputMaybe<Scalars['String']>;
  firstname: Scalars['String'];
  lastname: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
};

export type CreatePatientFileInput = {
  filename: Scalars['String'];
  key: Scalars['String'];
  objectId: Scalars['String'];
  objectType: Scalars['String'];
};

export type CreatePaymentSessionInput = {
  cancelUrl: Scalars['String'];
  orderId: Scalars['String'];
  successUrl: Scalars['String'];
};

export type CreatePresignedUrlInput = {
  filename: Scalars['String'];
  mimetype: Scalars['String'];
  objectId: Scalars['String'];
  objectType: Scalars['String'];
};

export type DeleteFilesInput = {
  files: Array<DeletePatientFileInput>;
};

export type DeletePatientFileInput = {
  filename: Scalars['String'];
  key: Scalars['String'];
  objectId: Scalars['String'];
  objectType: Scalars['String'];
};

export type DesmosActStatus = {
  __typename?: 'DesmosActStatus';
  createdAt?: Maybe<Scalars['DateTime']>;
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type DesmosConfig = {
  __typename?: 'DesmosConfig';
  apiUrl: Scalars['String'];
  finess?: Maybe<Scalars['String']>;
  identityApiUrl: Scalars['String'];
};

export enum DeviceUsageTrigger {
  Auto = 'AUTO',
  Manual = 'MANUAL'
}

export type DictaphoneFile = {
  __typename?: 'DictaphoneFile';
  filename: Scalars['String'];
  isBillingJustification?: Maybe<Scalars['Boolean']>;
  isRecording?: Maybe<Scalars['Boolean']>;
  key: Scalars['String'];
  objectType?: Maybe<Scalars['String']>;
  recordingAnnotations: Array<Maybe<RecordingAnnotation>>;
  text?: Maybe<Scalars['String']>;
  uploadedBy?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export enum EmergencyRoomStatus {
  Available = 'Available',
  InProgress = 'InProgress',
  Inactive = 'Inactive',
  Standby = 'Standby'
}

export type Etablissement = {
  __typename?: 'Etablissement';
  _id: Scalars['String'];
  active: Scalars['Boolean'];
  address?: Maybe<Scalars['String']>;
  admin?: Maybe<Admin>;
  autoValidateIdentity?: Maybe<Scalars['Boolean']>;
  city?: Maybe<Scalars['String']>;
  contract?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  desmosConfig?: Maybe<DesmosConfig>;
  files?: Maybe<Array<EtablissementFile>>;
  finess?: Maybe<Scalars['String']>;
  identityJustificationTypes?: Maybe<Array<IdentityJustificationTypeItem>>;
  isJoinableByPatients?: Maybe<Scalars['Boolean']>;
  language?: Maybe<Scalars['String']>;
  logo?: Maybe<EtablissementFile>;
  meetingBackgrounds?: Maybe<Array<EtablissementFile>>;
  name: Scalars['String'];
  ordoclicEntityId?: Maybe<Scalars['String']>;
  ordoclicVidalLicense?: Maybe<OrdoclicVidalLicense>;
  phone?: Maybe<Scalars['String']>;
  plugins: Array<Maybe<Plugin>>;
  /** Default locale for accounts created within this establishment. */
  preferredLanguage?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  structureActivity?: Maybe<OrdoclicStructureActivity>;
  trustedActors?: Maybe<Array<TrustedActor>>;
  zipCode?: Maybe<Scalars['String']>;
};

export type EtablissementFile = {
  __typename?: 'EtablissementFile';
  filename: Scalars['String'];
  key: Scalars['String'];
  objectType?: Maybe<Scalars['String']>;
  uploadedBy?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type Event = {
  __typename?: 'Event';
  _id: Scalars['String'];
  channels: Array<Channel>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emails?: Maybe<Array<Scalars['String']>>;
  object_id: Scalars['String'];
  object_type: EventObjectType;
  phones?: Maybe<Array<Scalars['String']>>;
  priority: Priority;
  recipients: Array<Recipient>;
  type: EventType;
};

export enum EventObjectType {
  Admin = 'ADMIN',
  Consultation = 'CONSULTATION',
  Network = 'NETWORK',
  Order = 'ORDER',
  Patient = 'PATIENT',
  Room = 'ROOM',
  Shift = 'SHIFT',
  ShiftProposal = 'SHIFT_PROPOSAL',
  Staff = 'STAFF',
  Telexpertise = 'TELEXPERTISE'
}

export enum EventType {
  ConsultationInvitation = 'CONSULTATION_INVITATION',
  ConsultationOrderCreated = 'CONSULTATION_ORDER_CREATED',
  ConsultationOrderReminder = 'CONSULTATION_ORDER_REMINDER',
  ConsultationOrderUpdated = 'CONSULTATION_ORDER_UPDATED',
  ConsultationReminder = 'CONSULTATION_REMINDER',
  DoctorOnboarding = 'DOCTOR_ONBOARDING',
  EmailVerification = 'EMAIL_VERIFICATION',
  EmergencyInvite = 'EMERGENCY_INVITE',
  ExpertiseCreated = 'EXPERTISE_CREATED',
  ExpertiseOrderCreated = 'EXPERTISE_ORDER_CREATED',
  ExpertiseOrderReminder = 'EXPERTISE_ORDER_REMINDER',
  ExpertiseOrderUpdated = 'EXPERTISE_ORDER_UPDATED',
  ExpertiseUpdated = 'EXPERTISE_UPDATED',
  FirstPassword = 'FIRST_PASSWORD',
  IdentityChangeNotification = 'IDENTITY_CHANGE_NOTIFICATION',
  LostDeviceDisabled = 'LOST_DEVICE_DISABLED',
  MeetingLinkOrderCreated = 'MEETING_LINK_ORDER_CREATED',
  MeetingLinkOrderReminder = 'MEETING_LINK_ORDER_REMINDER',
  MeetingLinkOrderUpdated = 'MEETING_LINK_ORDER_UPDATED',
  NetworkConsultationOrder = 'NETWORK_CONSULTATION_ORDER',
  NetworkDailySummary = 'NETWORK_DAILY_SUMMARY',
  NetworkExpertiseOrder = 'NETWORK_EXPERTISE_ORDER',
  NetworkInvitationSent = 'NETWORK_INVITATION_SENT',
  NetworkJoinRequestAccepted = 'NETWORK_JOIN_REQUEST_ACCEPTED',
  NetworkJoinRequestDeclined = 'NETWORK_JOIN_REQUEST_DECLINED',
  NetworkOrderAccepted = 'NETWORK_ORDER_ACCEPTED',
  NetworkPendingOrder = 'NETWORK_PENDING_ORDER',
  OrderCreated = 'ORDER_CREATED',
  OrderReminder = 'ORDER_REMINDER',
  OrderUpdated = 'ORDER_UPDATED',
  PatientAccountActivation = 'PATIENT_ACCOUNT_ACTIVATION',
  PhoneVerificationOtp = 'PHONE_VERIFICATION_OTP',
  PlanningDailySummary = 'PLANNING_DAILY_SUMMARY',
  SendConsultationFiles = 'SEND_CONSULTATION_FILES',
  ShiftClaimed = 'SHIFT_CLAIMED',
  ShiftProposalApproved = 'SHIFT_PROPOSAL_APPROVED',
  ShiftProposalCreated = 'SHIFT_PROPOSAL_CREATED',
  ShiftProposalRejected = 'SHIFT_PROPOSAL_REJECTED',
  ShiftReminder = 'SHIFT_REMINDER'
}

export type Expertise = {
  __typename?: 'Expertise';
  _id: Scalars['String'];
  chatRoom?: Maybe<ChatRoom>;
  comment?: Maybe<Scalars['String']>;
  conclusion?: Maybe<Scalars['String']>;
  consultations?: Maybe<Array<Consultation>>;
  createdBy?: Maybe<Staff>;
  diagnostic?: Maybe<Scalars['String']>;
  dictaphones?: Maybe<Array<DictaphoneFile>>;
  endDate?: Maybe<Scalars['DateTime']>;
  files: Array<ExpertiseFile>;
  formSubmissions?: Maybe<Array<FormSubmission>>;
  medecin?: Maybe<Staff>;
  patient: Patient;
  speciality?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  status: ExpertiseStatus;
};

export type ExpertiseFile = {
  __typename?: 'ExpertiseFile';
  filename: Scalars['String'];
  key: Scalars['String'];
  objectType?: Maybe<Scalars['String']>;
  uploadedBy?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export enum ExpertiseStatus {
  Closed = 'Closed',
  Draft = 'Draft',
  Omnidoc = 'Omnidoc',
  Reviewed = 'Reviewed',
  Sent = 'Sent'
}

export type File = {
  __typename?: 'File';
  filename: Scalars['String'];
  key: Scalars['String'];
  objectType?: Maybe<Scalars['String']>;
  uploadedBy?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type FormField = {
  __typename?: 'FormField';
  id: Scalars['String'];
  label: Scalars['String'];
  options?: Maybe<Array<Scalars['String']>>;
  required: Scalars['Boolean'];
  type: FormFieldType;
};

export enum FormFieldType {
  Boolean = 'Boolean',
  Date = 'Date',
  DateTime = 'DateTime',
  Multiple = 'Multiple',
  Number = 'Number',
  Text = 'Text',
  TextArea = 'TextArea'
}

export type FormResponse = {
  __typename?: 'FormResponse';
  fieldId: Scalars['String'];
  value: Scalars['JSON'];
};

export type FormResponseInput = {
  fieldId: Scalars['String'];
  value: Scalars['JSON'];
};

export type FormSubmission = {
  __typename?: 'FormSubmission';
  _id: Scalars['String'];
  consultation?: Maybe<Consultation>;
  createdAt: Scalars['DateTime'];
  establishment?: Maybe<Etablissement>;
  ethicsResponse?: Maybe<Scalars['String']>;
  expertise?: Maybe<Expertise>;
  patient: Patient;
  purpose?: Maybe<FormSubmissionPurpose>;
  respondedAt?: Maybe<Scalars['DateTime']>;
  respondedBy?: Maybe<Account>;
  responses: Array<FormResponse>;
  status: FormSubmissionStatus;
  submittedAt?: Maybe<Scalars['DateTime']>;
  submittedBy: Account;
  tags: Array<Scalars['String']>;
  template: FormTemplate;
  updatedAt: Scalars['DateTime'];
};

export enum FormSubmissionPurpose {
  ReadinessChecklist = 'ReadinessChecklist'
}

export enum FormSubmissionStatus {
  Draft = 'Draft',
  Resolved = 'Resolved',
  Submitted = 'Submitted'
}

export type FormTemplate = {
  __typename?: 'FormTemplate';
  _id: Scalars['String'];
  aiOutputConfig?: Maybe<AiOutputConfig>;
  categories: Array<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  createdBy: Staff;
  description: Scalars['String'];
  fields: Array<FormField>;
  fillablePdf?: Maybe<File>;
  isActive: Scalars['Boolean'];
  lastUpdatedBy: Staff;
  pdfFields?: Maybe<Array<PdfField>>;
  tags: Array<Scalars['String']>;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  version: Scalars['Float'];
};

export enum Gender {
  F = 'F',
  I = 'I',
  M = 'M',
  O = 'O'
}

export type GetPaymentStatusInput = {
  orderId: Scalars['String'];
};

export type IdentityJustificationTypeItem = {
  __typename?: 'IdentityJustificationTypeItem';
  _id: Scalars['String'];
  confidenceLevel: Scalars['String'];
  label: Scalars['String'];
};

export type Imc = {
  __typename?: 'Imc';
  indice: Scalars['String'];
  value: Scalars['Float'];
};

export type ImmediateConsultationConfig = {
  __typename?: 'ImmediateConsultationConfig';
  enabled: Scalars['Boolean'];
  maxWaitingPatients?: Maybe<Scalars['Float']>;
  paymentReceiver?: Maybe<Staff>;
  price?: Maybe<Scalars['Float']>;
  requirePaymentUpfront: Scalars['Boolean'];
};

export type JoinedWaitingRoom = {
  __typename?: 'JoinedWaitingRoom';
  isAvailable: Scalars['Boolean'];
  isOccupied: Scalars['Boolean'];
  waitingRoom: WaitingRoom;
};

export enum KeycloakUserType {
  Admin = 'ADMIN',
  ApiKey = 'API_KEY',
  Patient = 'PATIENT',
  Staff = 'STAFF'
}

export type KnowledgeBaseEmbeddedDocument = {
  __typename?: 'KnowledgeBaseEmbeddedDocument';
  chunkCount: Scalars['Float'];
  description?: Maybe<Scalars['String']>;
  filename: Scalars['String'];
  key: Scalars['String'];
  lastReprocessedAt?: Maybe<Scalars['DateTime']>;
  objectType?: Maybe<Scalars['String']>;
  pageCount: Scalars['Float'];
  processedAt?: Maybe<Scalars['DateTime']>;
  processingError?: Maybe<Scalars['String']>;
  qdrantPointIds: Array<Scalars['String']>;
  status: ProcessingStatus;
  title: Scalars['String'];
  uploadedBy?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type MarkEventAsRead = {
  eventId: Scalars['String'];
  recipientId: Scalars['String'];
};

export type MedconnectAgentConfig = {
  __typename?: 'MedconnectAgentConfig';
  /** List of tool names that are explicitly disabled. This takes precedence over enabledTools. */
  disabledTools?: Maybe<Array<Scalars['String']>>;
  /** List of tool names that are explicitly enabled. If not provided, all tools are considered enabled unless specified in disabledTools. */
  enabledTools?: Maybe<Array<Scalars['String']>>;
};

/**
 * MedicalActTemplate - Admin-defined templates for medical acts
 *
 * Templates can be:
 * - Global (isGlobal=true, establishment=null): Created by super admins, visible to all establishments
 * - Establishment-specific (isGlobal=false, establishment=id): Created by admins, visible only to that establishment
 */
export type MedicalActTemplate = {
  __typename?: 'MedicalActTemplate';
  _id: Scalars['String'];
  code: Scalars['String'];
  createdBy: Account;
  description?: Maybe<Scalars['String']>;
  establishment?: Maybe<Etablissement>;
  icd10Code?: Maybe<Scalars['String']>;
  icd10Description?: Maybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  isGlobal: Scalars['Boolean'];
  name: Scalars['String'];
  price: Scalars['Float'];
};

export type MeetingLink = {
  __typename?: 'MeetingLink';
  _id: Scalars['String'];
  availabilities: Array<MeetingLinkAvailability>;
  busyEnabled?: Maybe<Scalars['Boolean']>;
  busySlots: Array<MeetingLinkBusySlot>;
  createdBy: Staff;
  description?: Maybe<Scalars['String']>;
  immediateConsultationConfig?: Maybe<ImmediateConsultationConfig>;
  isPrioritized?: Maybe<Scalars['Boolean']>;
  maxDays: Scalars['Float'];
  name: Scalars['String'];
  slug: Scalars['String'];
  specialities: Array<MeetingLinkSpeciality>;
  staffs: Array<Staff>;
  waitingRoom?: Maybe<WaitingRoom>;
};

export type MeetingLinkAvailability = {
  __typename?: 'MeetingLinkAvailability';
  _id: Scalars['String'];
  additionalAddress?: Maybe<Scalars['String']>;
  address?: Maybe<MeetingLinkAvailabilityAddress>;
  avgMeetingDuration: Scalars['Float'];
  formTemplate?: Maybe<FormTemplate>;
  fromLink: Scalars['String'];
  isRecurrence: Scalars['Boolean'];
  meetingPlace: AvailabilityMeetingPlace;
  notes: Scalars['String'];
  paymentConfig?: Maybe<MeetingLinkAvailabilityPaymentConfig>;
  recurrenceDays: Array<MeetingLinkAvailabilityRecurrenceDay>;
  scheduledDays: Array<MeetingLinkAvailabilityScheduledDay>;
  serviceArea?: Maybe<ServiceArea>;
  specialities: Array<Scalars['String']>;
  unavailabilities?: Maybe<Array<MeetingLinkUnavailability>>;
};

export type MeetingLinkAvailabilityAddress = {
  __typename?: 'MeetingLinkAvailabilityAddress';
  description: Scalars['String'];
  placeId: Scalars['String'];
};

export type MeetingLinkAvailabilityPaymentConfig = {
  __typename?: 'MeetingLinkAvailabilityPaymentConfig';
  basePrice?: Maybe<Scalars['Float']>;
  paymentReceiver?: Maybe<PublicStaffPaymentConfig>;
  priceModifiers?: Maybe<Array<MeetingLinkAvailabilityPriceModifier>>;
  requiresPayment?: Maybe<Scalars['Boolean']>;
};

export type MeetingLinkAvailabilityPeriod = {
  __typename?: 'MeetingLinkAvailabilityPeriod';
  close: Scalars['Float'];
  open: Scalars['Float'];
};

export type MeetingLinkAvailabilityPriceModifier = {
  __typename?: 'MeetingLinkAvailabilityPriceModifier';
  meetingPlace: AvailabilityMeetingPlace;
  modifier: Scalars['Float'];
};

export type MeetingLinkAvailabilityRecurrenceDay = {
  __typename?: 'MeetingLinkAvailabilityRecurrenceDay';
  day: Scalars['Float'];
  periods: Array<MeetingLinkAvailabilityPeriod>;
  timeZone: Scalars['String'];
};

export type MeetingLinkAvailabilityScheduledDay = {
  __typename?: 'MeetingLinkAvailabilityScheduledDay';
  day: Scalars['String'];
  format: Scalars['String'];
  periods: Array<MeetingLinkAvailabilityPeriod>;
  timeZone: Scalars['String'];
};

export type MeetingLinkBusySlot = {
  __typename?: 'MeetingLinkBusySlot';
  end: Scalars['DateTime'];
  start: Scalars['DateTime'];
};

export type MeetingLinkOrder = {
  __typename?: 'MeetingLinkOrder';
  _id: Scalars['String'];
  acceptedBy?: Maybe<Staff>;
  cancelReason?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  companion?: Maybe<MeetingLinkOrderCompanion>;
  consultation?: Maybe<Consultation>;
  createdBy: Patient;
  dictaphones?: Maybe<Array<MeetingLinkOrderDictaphone>>;
  files?: Maybe<Array<MeetingLinkOrderFile>>;
  formSubmission?: Maybe<FormSubmission>;
  meetingLink?: Maybe<MeetingLink>;
  meetingPlace: MeetingPlace;
  patientConsent?: Maybe<PatientConsent>;
  payment?: Maybe<MeetingLinkOrderPayment>;
  paymentCompleted?: Maybe<Scalars['Boolean']>;
  paymentReceiver?: Maybe<Staff>;
  price?: Maybe<Scalars['Float']>;
  receiverId: Scalars['String'];
  receiverType: Scalars['String'];
  referenceId: Scalars['String'];
  refuseReason?: Maybe<Scalars['String']>;
  requiresPayment?: Maybe<Scalars['Boolean']>;
  speciality: Scalars['String'];
  startDate: Scalars['DateTime'];
  status: OrderStatus;
};

export type MeetingLinkOrderCompanion = {
  __typename?: 'MeetingLinkOrderCompanion';
  confidentialityAgreement: Scalars['Boolean'];
  email?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  relationshipType: Scalars['String'];
  relationshipTypeDisplay?: Maybe<Scalars['String']>;
};

export type MeetingLinkOrderDictaphone = {
  __typename?: 'MeetingLinkOrderDictaphone';
  filename: Scalars['String'];
  key: Scalars['String'];
  text?: Maybe<Scalars['String']>;
};

export type MeetingLinkOrderFile = {
  __typename?: 'MeetingLinkOrderFile';
  filename: Scalars['String'];
  key: Scalars['String'];
  objectType?: Maybe<Scalars['String']>;
  uploadedBy?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type MeetingLinkOrderPayment = {
  __typename?: 'MeetingLinkOrderPayment';
  paid?: Maybe<Scalars['Boolean']>;
  paymentType?: Maybe<PaymentType>;
  payment_Session_id?: Maybe<Scalars['String']>;
  pi?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  receiptUrl?: Maybe<Scalars['String']>;
  validatedAt?: Maybe<Scalars['DateTime']>;
};

export type MeetingLinkSpeciality = {
  __typename?: 'MeetingLinkSpeciality';
  code: Scalars['String'];
  name: Scalars['String'];
  price: Scalars['Float'];
};

export type MeetingLinkUnavailability = {
  __typename?: 'MeetingLinkUnavailability';
  _id: Scalars['String'];
  createdAt: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  endTime?: Maybe<Scalars['Float']>;
  reason?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  startTime?: Maybe<Scalars['Float']>;
};

export type MeetingLinksSearchResult = Etablissement | MeetingLink;

export type MeetingPlace = {
  __typename?: 'MeetingPlace';
  apartment?: Maybe<Scalars['String']>;
  coordinatesLat?: Maybe<Scalars['Float']>;
  coordinatesLng?: Maybe<Scalars['Float']>;
  description?: Maybe<Scalars['String']>;
  doorCode?: Maybe<Scalars['String']>;
  floor?: Maybe<Scalars['String']>;
  instructions?: Maybe<Scalars['String']>;
  placeId?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
};

export type Message = {
  __typename?: 'Message';
  _id: Scalars['String'];
  author: Staff;
  content: Scalars['String'];
  date: Scalars['DateTime'];
  readBy: Array<Staff>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addSavedAddress: Patient;
  createFormSubmission: FormSubmission;
  createOrder: MeetingLinkOrder;
  createPaymentSession: PaymentSessionResponse;
  deleteFiles: Scalars['String'];
  deleteOrder: Scalars['Boolean'];
  deleteSavedAddress: Patient;
  generatePresignedUrl: Scalars['String'];
  markEventAsRead: Array<Event>;
  sendExpertiseMessage: ChatRoom;
  signUp: Scalars['String'];
  updateConsultationStatus: Consultation;
  updateMyInfos: Patient;
  updateOrder: MeetingLinkOrder;
  updateOrderStatus: MeetingLinkOrder;
  updatePatientDataReuseConsent: Consultation;
  updatePatientLocation: Consultation;
  updateSavedAddress: Patient;
  uploadFile: Patient;
};


export type MutationAddSavedAddressArgs = {
  payload: SavedAddressInput;
};


export type MutationCreateFormSubmissionArgs = {
  payload: CreateFormSubmissionInput;
};


export type MutationCreateOrderArgs = {
  payload: CreateOrderInput;
};


export type MutationCreatePaymentSessionArgs = {
  payload: CreatePaymentSessionInput;
};


export type MutationDeleteFilesArgs = {
  payload: DeleteFilesInput;
};


export type MutationDeleteOrderArgs = {
  orderId: Scalars['String'];
};


export type MutationDeleteSavedAddressArgs = {
  addressId: Scalars['String'];
};


export type MutationGeneratePresignedUrlArgs = {
  payload: CreatePresignedUrlInput;
};


export type MutationMarkEventAsReadArgs = {
  payload: MarkEventAsRead;
};


export type MutationSendExpertiseMessageArgs = {
  payload: SendExpertiseMessageInput;
};


export type MutationSignUpArgs = {
  payload: SignUpInput;
};


export type MutationUpdateConsultationStatusArgs = {
  payload: UpdateConsultationStatus;
};


export type MutationUpdateMyInfosArgs = {
  payload: UpdatePatientInput;
};


export type MutationUpdateOrderArgs = {
  input: CreateOrderInput;
  orderId: Scalars['String'];
};


export type MutationUpdateOrderStatusArgs = {
  payload: UpdateOrderStatus;
};


export type MutationUpdatePatientDataReuseConsentArgs = {
  payload: UpdatePatientDataReuseConsentInput;
};


export type MutationUpdatePatientLocationArgs = {
  payload: UpdatePatientLocationInput;
};


export type MutationUpdateSavedAddressArgs = {
  payload: UpdateSavedAddressInput;
};


export type MutationUploadFileArgs = {
  payload: UploadFileInput;
};

export type Network = {
  __typename?: 'Network';
  _id: Scalars['String'];
  chatRoom?: Maybe<ChatRoom>;
  coverPhoto?: Maybe<NetworkFile>;
  createdBy: Account;
  description?: Maybe<Scalars['String']>;
  members: Array<Scalars['String']>;
  name: Scalars['String'];
  pendingMembers: Array<Account>;
  pendingOrders: Array<Order>;
  privacy: NetworkPrivacy;
};

export type NetworkFile = {
  __typename?: 'NetworkFile';
  filename: Scalars['String'];
  key: Scalars['String'];
  objectType?: Maybe<Scalars['String']>;
  uploadedBy?: Maybe<Scalars['String']>;
  url: Scalars['String'];
};

export enum NetworkPrivacy {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type Order = {
  __typename?: 'Order';
  _id: Scalars['String'];
  acceptedBy?: Maybe<Staff>;
  receiverId: Scalars['String'];
  receiverType: Scalars['String'];
  referenceId: Scalars['String'];
  status: OrderStatus;
};

export type OrderFileInput = {
  filename: Scalars['String'];
  key: Scalars['String'];
  objectType?: InputMaybe<Scalars['String']>;
  uploadedBy?: InputMaybe<Scalars['String']>;
};

export type OrderMeetingPlaceInput = {
  apartment?: InputMaybe<Scalars['String']>;
  coordinates?: InputMaybe<CoordinatesInput>;
  description: Scalars['String'];
  doorCode?: InputMaybe<Scalars['String']>;
  floor?: InputMaybe<Scalars['String']>;
  instructions?: InputMaybe<Scalars['String']>;
  placeId?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
};

/**
 * PatientConsentInput - Regulatory compliance for ETH.03, ETH.04, ETH.11, ETH.12, ETH.58
 * Input type for patient consent data during teleconsultation booking
 */
export type OrderPatientConsentInput = {
  acceptedAt: Scalars['DateTime'];
  acceptedPricing: Scalars['Boolean'];
  dataForResearch?: InputMaybe<Scalars['Boolean']>;
  dataForServiceImprovement?: InputMaybe<Scalars['Boolean']>;
  freeChoice: Scalars['Boolean'];
  informedAboutTeleconsultation: Scalars['Boolean'];
};

export type OrderPatientInfoInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
};

export enum OrderStatus {
  Accepted = 'Accepted',
  Canceled = 'Canceled',
  Completed = 'Completed',
  Confirmed = 'Confirmed',
  ConsultationCreated = 'Consultation_Created',
  Draft = 'Draft',
  ExpertiseCreated = 'Expertise_Created',
  InProgress = 'In_Progress',
  NoShow = 'No_Show',
  Pending = 'Pending',
  Refused = 'Refused',
  Rescheduled = 'Rescheduled'
}

export type OrdoclicPrescription = {
  __typename?: 'OrdoclicPrescription';
  comment?: Maybe<Scalars['String']>;
  doctor: Staff;
  favorite: Scalars['Boolean'];
  id: Scalars['String'];
  legacyPrescriptionUUID?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  patient: Patient;
  prescriptionLines: Array<OrdoclicPrescriptionLine>;
  source: OrdoclicPrescriptionSource;
  status: Scalars['String'];
};

export type OrdoclicPrescriptionIndication = {
  __typename?: 'OrdoclicPrescriptionIndication';
  amm: Scalars['Boolean'];
  bdmRef: Scalars['String'];
  label: Scalars['String'];
};

export type OrdoclicPrescriptionLine = {
  __typename?: 'OrdoclicPrescriptionLine';
  ald: Scalars['Boolean'];
  apsi: Scalars['Boolean'];
  bdmRef: Scalars['String'];
  code: Scalars['String'];
  codeDci?: Maybe<Scalars['String']>;
  codeType: Scalars['String'];
  comment?: Maybe<Scalars['String']>;
  commercialName: Scalars['String'];
  conditionalDispensation?: Maybe<Scalars['String']>;
  dc: Scalars['Boolean'];
  dcName: Scalars['String'];
  displayName: Scalars['String'];
  durationRent: Scalars['Boolean'];
  groupId: Scalars['Float'];
  indication?: Maybe<OrdoclicPrescriptionIndication>;
  longCode: Scalars['String'];
  lppr?: Maybe<OrdoclicPrescriptionLppr>;
  maxRenewals: Scalars['Float'];
  motive?: Maybe<Scalars['String']>;
  performerName?: Maybe<Scalars['String']>;
  performerOptions?: Maybe<OrdoclicPrescriptionPerformerOptions>;
  posology: Array<OrdoclicPrescriptionPosology>;
  prescriber?: Maybe<Scalars['String']>;
  prevention: Scalars['Boolean'];
  reason?: Maybe<OrdoclicPrescriptionReason>;
  ref13?: Maybe<Scalars['String']>;
  route?: Maybe<OrdoclicPrescriptionRoute>;
  specialMentionCode?: Maybe<Scalars['String']>;
  specialMentionDisplay?: Maybe<Scalars['String']>;
  substitutability: Scalars['String'];
  workAccident: Scalars['Boolean'];
};

export type OrdoclicPrescriptionLppr = {
  __typename?: 'OrdoclicPrescriptionLppr';
  duration: Scalars['Float'];
  quantity: Scalars['Float'];
  specification?: Maybe<Scalars['String']>;
};

export type OrdoclicPrescriptionPerformerOptions = {
  __typename?: 'OrdoclicPrescriptionPerformerOptions';
  display: Scalars['String'];
  value: Scalars['String'];
};

export type OrdoclicPrescriptionPosology = {
  __typename?: 'OrdoclicPrescriptionPosology';
  duration: Scalars['Float'];
  durationUnit: Scalars['String'];
  endDate: Scalars['DateTime'];
  posologyText?: Maybe<Scalars['String']>;
  prescriptionQuantity: Scalars['String'];
  prescriptionUnit: OrdoclicPrescriptionUnit;
  rank: Scalars['Float'];
  route: OrdoclicPrescriptionRoute;
  startDate: Scalars['DateTime'];
  type: Scalars['String'];
};

export type OrdoclicPrescriptionReason = {
  __typename?: 'OrdoclicPrescriptionReason';
  bdmRef: Scalars['String'];
  code: Scalars['String'];
  codeType: Scalars['String'];
  label: Scalars['String'];
};

export type OrdoclicPrescriptionRoute = {
  __typename?: 'OrdoclicPrescriptionRoute';
  bdmRef: Scalars['String'];
  label: Scalars['String'];
};

export type OrdoclicPrescriptionSource = {
  __typename?: 'OrdoclicPrescriptionSource';
  date: Scalars['DateTime'];
  name: Scalars['String'];
  version: Scalars['String'];
};

export type OrdoclicPrescriptionUnit = {
  __typename?: 'OrdoclicPrescriptionUnit';
  bdmRef: Scalars['String'];
  genderFeminine: Scalars['Boolean'];
  plural: Scalars['String'];
  singular: Scalars['String'];
};

export type OrdoclicStructureActivity = {
  __typename?: 'OrdoclicStructureActivity';
  code: StructureActivityCode;
};

export type OrdoclicVidalLicense = {
  __typename?: 'OrdoclicVidalLicense';
  id: Scalars['String'];
};

export type Parent = {
  __typename?: 'Parent';
  _id: Scalars['String'];
  city?: Maybe<Scalars['String']>;
  cp?: Maybe<Scalars['Int']>;
  email?: Maybe<Scalars['String']>;
  firstname: Scalars['String'];
  lastname: Scalars['String'];
  patient: Patient;
  phone?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
};

export type Patient = {
  __typename?: 'Patient';
  _id: Scalars['String'];
  account?: Maybe<Scalars['String']>;
  active: Scalars['Boolean'];
  agreement: Scalars['String'];
  allergy?: Maybe<Scalars['String']>;
  attendingPhysician?: Maybe<AttendingPhysician>;
  avatarFileId?: Maybe<Scalars['String']>;
  background?: Maybe<Scalars['String']>;
  caisse?: Maybe<Scalars['String']>;
  codeGestion?: Maybe<Scalars['String']>;
  codeRegime?: Maybe<Scalars['String']>;
  consultations: Array<Consultation>;
  contactInfo?: Maybe<ContactInfo>;
  createdBy?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  establishment?: Maybe<Etablissement>;
  events: Array<Event>;
  expertises: Array<Expertise>;
  files?: Maybe<Array<PatientFile>>;
  formSubmissions: Array<FormSubmission>;
  groups?: Maybe<Array<Scalars['String']>>;
  height?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['String']>;
  identityConfirmed?: Maybe<Scalars['Boolean']>;
  imc?: Maybe<Imc>;
  insEmitter?: Maybe<Scalars['String']>;
  insNIR?: Maybe<Scalars['String']>;
  insOID?: Maybe<Scalars['String']>;
  insuranceProvider?: Maybe<Scalars['String']>;
  insured?: Maybe<Scalars['String']>;
  insuredRelationship?: Maybe<Scalars['String']>;
  isConsultationReady?: Maybe<Scalars['Boolean']>;
  isProfileComplete?: Maybe<Scalars['Boolean']>;
  licenses: Array<Scalars['String']>;
  medconnectAgentConfig?: Maybe<MedconnectAgentConfig>;
  /** SEHA (en-SA) nationality: 'saudi' | 'non-saudi' */
  nationality?: Maybe<Scalars['String']>;
  netsoinsId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  orders: Array<MeetingLinkOrder>;
  parents?: Maybe<Array<Parent>>;
  pluginId?: Maybe<Scalars['String']>;
  policies: Array<Scalars['String']>;
  primaryInsurance?: Maybe<Scalars['String']>;
  primaryPharmacy?: Maybe<Scalars['String']>;
  primaryPolicy?: Maybe<Scalars['String']>;
  roles: Array<Role>;
  savedAddresses?: Maybe<Array<SavedAddress>>;
  secondaryInsurance?: Maybe<Scalars['String']>;
  secondaryPolicy?: Maybe<Scalars['String']>;
  secu: Scalars['String'];
  subscription: SubscriptionType;
  treatment?: Maybe<Scalars['String']>;
  type: KeycloakUserType;
  userInfo: PatientInfo;
  vaccins?: Maybe<Scalars['String']>;
  weight?: Maybe<Scalars['Float']>;
};

export type PatientConsent = {
  __typename?: 'PatientConsent';
  acceptedAt?: Maybe<Scalars['DateTime']>;
  acceptedPricing: Scalars['Boolean'];
  dataForResearch?: Maybe<Scalars['Boolean']>;
  dataForServiceImprovement?: Maybe<Scalars['Boolean']>;
  dataReuseConsent?: Maybe<Scalars['Boolean']>;
  freeChoice: Scalars['Boolean'];
  informedAboutTeleconsultation: Scalars['Boolean'];
  recordingConsent?: Maybe<Scalars['Boolean']>;
  version?: Maybe<Scalars['String']>;
};

export type PatientFile = {
  __typename?: 'PatientFile';
  filename: Scalars['String'];
  key: Scalars['String'];
  objectType?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type PatientInfo = {
  __typename?: 'PatientInfo';
  birthFirstName?: Maybe<Scalars['String']>;
  birthName?: Maybe<Scalars['String']>;
  birthPlace?: Maybe<Scalars['String']>;
  birthPlaceCode?: Maybe<Scalars['String']>;
  birthSurname?: Maybe<Scalars['String']>;
  birthday?: Maybe<Scalars['DateTime']>;
  gender?: Maybe<Gender>;
  identityJustificationType?: Maybe<Scalars['String']>;
  identitySupplementaryAttribute?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  notificationTimezone?: Maybe<Scalars['String']>;
  surname: Scalars['String'];
  username?: Maybe<Scalars['String']>;
};

export type PatientQueueEntry = {
  __typename?: 'PatientQueueEntry';
  isJoinRequested?: Maybe<Scalars['Boolean']>;
  patient: Patient;
  position?: Maybe<Scalars['Float']>;
  waitingRoom?: Maybe<WaitingRoom>;
};

export type PatientWaitingStatus = {
  __typename?: 'PatientWaitingStatus';
  canJoin: Scalars['Boolean'];
  consultationId: Scalars['String'];
  doctorStatus: WaitingDoctorStatus;
};

export type PaymentSessionResponse = {
  __typename?: 'PaymentSessionResponse';
  sessionId: Scalars['String'];
};

export type PaymentStatusResponse = {
  __typename?: 'PaymentStatusResponse';
  paid: Scalars['Boolean'];
  receiptUrl?: Maybe<Scalars['String']>;
  sessionId?: Maybe<Scalars['String']>;
};

export enum PaymentType {
  Card = 'Card',
  Cash = 'Cash',
  Check = 'Check',
  Transfer = 'Transfer'
}

export type PdfField = {
  __typename?: 'PdfField';
  fontSize?: Maybe<Scalars['Float']>;
  height: Scalars['Float'];
  label: Scalars['String'];
  multiline?: Maybe<Scalars['Boolean']>;
  page: Scalars['Float'];
  type: Scalars['String'];
  width: Scalars['Float'];
  x: Scalars['Float'];
  y: Scalars['Float'];
};

export type Permission = {
  __typename?: 'Permission';
  action: Scalars['String'];
  resource: Scalars['String'];
};

export type Plugin = {
  __typename?: 'Plugin';
  apiUrl?: Maybe<Scalars['String']>;
  pluginUrl: Scalars['String'];
};

export type Pregnancy = {
  __typename?: 'Pregnancy';
  _id: Scalars['String'];
  createdBy: Staff;
  establishment: Etablissement;
  expectedDueDate?: Maybe<Scalars['DateTime']>;
  lmpDate: Scalars['DateTime'];
  notes?: Maybe<Scalars['String']>;
  patient: Patient;
  status: Scalars['String'];
};

export enum Priority {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export enum ProcessingStatus {
  Completed = 'COMPLETED',
  Deleted = 'DELETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING'
}

export type ProfessionalConsent = {
  __typename?: 'ProfessionalConsent';
  consentDate?: Maybe<Scalars['String']>;
  dataReuseConsent?: Maybe<Scalars['Boolean']>;
  preConsultationConsent?: Maybe<Scalars['Boolean']>;
  teleconsultationUnderstandingAssessed?: Maybe<Scalars['Boolean']>;
  teleconsultationUnderstandingAssessedAt?: Maybe<Scalars['String']>;
  teleconsultationUnderstandingAssessmentVersion?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
};

export type PublicStaffPaymentConfig = {
  __typename?: 'PublicStaffPaymentConfig';
  _id: Scalars['String'];
  stripe: Scalars['String'];
  stripeActivated: Scalars['Boolean'];
  userInfo: PublicStaffPaymentConfigUserInfo;
};

export type PublicStaffPaymentConfigUserInfo = {
  __typename?: 'PublicStaffPaymentConfigUserInfo';
  name: Scalars['String'];
  surname: Scalars['String'];
};

export type QueriedEstablishment = {
  __typename?: 'QueriedEstablishment';
  _id: Scalars['String'];
  active: Scalars['Boolean'];
  address?: Maybe<Scalars['String']>;
  admin?: Maybe<Admin>;
  autoValidateIdentity?: Maybe<Scalars['Boolean']>;
  city?: Maybe<Scalars['String']>;
  contract?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  desmosConfig?: Maybe<DesmosConfig>;
  files?: Maybe<Array<EtablissementFile>>;
  finess?: Maybe<Scalars['String']>;
  identityJustificationTypes?: Maybe<Array<IdentityJustificationTypeItem>>;
  isJoinableByPatients?: Maybe<Scalars['Boolean']>;
  language?: Maybe<Scalars['String']>;
  logo?: Maybe<EtablissementFile>;
  meetingBackgrounds?: Maybe<Array<EtablissementFile>>;
  meetingLinks: Array<MeetingLink>;
  name: Scalars['String'];
  ordoclicEntityId?: Maybe<Scalars['String']>;
  ordoclicVidalLicense?: Maybe<OrdoclicVidalLicense>;
  phone?: Maybe<Scalars['String']>;
  plugins: Array<Maybe<Plugin>>;
  /** Default locale for accounts created within this establishment. */
  preferredLanguage?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  structureActivity?: Maybe<OrdoclicStructureActivity>;
  trustedActors?: Maybe<Array<TrustedActor>>;
  zipCode?: Maybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  activeFormTemplates: Array<FormTemplate>;
  chimeMeeting: ChimeMeeting;
  consultation: Consultation;
  establishment: QueriedEstablishment;
  formSubmission: FormSubmission;
  formTemplate: FormTemplate;
  getPatientWaitingStatus?: Maybe<PatientWaitingStatus>;
  getPaymentStatus: PaymentStatusResponse;
  meetingLink: MeetingLink;
  meetingLinkOrder: MeetingLinkOrder;
  meetingLinksSearch: Array<MeetingLinksSearchResult>;
  myInfos: Patient;
  prioritizedMeetingLinks: Array<MeetingLink>;
  trackedOrder: MeetingLinkOrder;
};


export type QueryChimeMeetingArgs = {
  meetingType: Scalars['String'];
  roomOrConsultationId: Scalars['String'];
  userId: Scalars['String'];
};


export type QueryConsultationArgs = {
  id: Scalars['String'];
};


export type QueryEstablishmentArgs = {
  slug: Scalars['String'];
};


export type QueryFormSubmissionArgs = {
  id: Scalars['String'];
};


export type QueryFormTemplateArgs = {
  id: Scalars['String'];
};


export type QueryGetPatientWaitingStatusArgs = {
  consultationId: Scalars['String'];
};


export type QueryGetPaymentStatusArgs = {
  payload: GetPaymentStatusInput;
};


export type QueryMeetingLinkArgs = {
  slug: Scalars['String'];
};


export type QueryMeetingLinkOrderArgs = {
  orderId: Scalars['String'];
};


export type QueryMeetingLinksSearchArgs = {
  phrase: Scalars['String'];
};


export type QueryTrackedOrderArgs = {
  referenceId: Scalars['String'];
};

export type Receiver = {
  __typename?: 'Receiver';
  peerId: Scalars['String'];
  staffId: Scalars['String'];
};

export type Recipient = {
  __typename?: 'Recipient';
  read?: Maybe<Scalars['Boolean']>;
  seen?: Maybe<Scalars['Boolean']>;
  type: RecipientType;
  userId: Scalars['String'];
};

export enum RecipientType {
  Admin = 'ADMIN',
  Patient = 'PATIENT',
  Staff = 'STAFF'
}

export type RecordingAnnotation = {
  __typename?: 'RecordingAnnotation';
  end: Scalars['Float'];
  id: Scalars['String'];
  note: Scalars['String'];
  start: Scalars['Float'];
};

export type Report = {
  __typename?: 'Report';
  _id: Scalars['String'];
  clinicalEntity: Scalars['JSONObject'];
  confidenceLevels: Scalars['JSONObject'];
  consultation: Consultation;
  createdAt: Scalars['DateTime'];
  lastUpdatedBy?: Maybe<Staff>;
  patient: Patient;
  responses: Array<ReportAnswer>;
  soapNote: Scalars['JSONObject'];
  submittedBy: Staff;
  template: ReportTemplate;
  transcription?: Maybe<Transcription>;
  updatedAt: Scalars['DateTime'];
};

export type ReportAnswer = {
  __typename?: 'ReportAnswer';
  response: Scalars['String'];
  sectionName: Scalars['String'];
};

export type ReportSection = {
  __typename?: 'ReportSection';
  description: Scalars['String'];
  name: Scalars['String'];
};

export type ReportTemplate = {
  __typename?: 'ReportTemplate';
  _id: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdBy: Staff;
  description: Scalars['String'];
  isDefault: Scalars['Boolean'];
  sections: Array<ReportSection>;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export enum Role {
  Admin = 'Admin',
  Auth = 'Auth',
  Charge = 'Charge',
  Consultation = 'Consultation',
  CustomDevices = 'CustomDevices',
  Files = 'Files',
  ItSupport = 'ItSupport',
  Netsoins = 'Netsoins',
  Parent = 'Parent',
  Patient = 'Patient',
  Room = 'Room',
  Staff = 'Staff',
  SuperAdmin = 'SuperAdmin'
}

export type Room = {
  __typename?: 'Room';
  _id: Scalars['String'];
  consultation: Consultation;
  creator: Staff;
  currentConsultation?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['String']>;
  meetings: Array<Array<Scalars['String']>>;
  receivers: Array<Receiver>;
  status?: Maybe<EmergencyRoomStatus>;
  streamer: Scalars['String'];
};

export type SavedAddress = {
  __typename?: 'SavedAddress';
  _id: Scalars['String'];
  apartment?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  coordinates?: Maybe<Coordinates>;
  country: Scalars['String'];
  doorCode?: Maybe<Scalars['String']>;
  floor?: Maybe<Scalars['String']>;
  instructions?: Maybe<Scalars['String']>;
  isDefault: Scalars['Boolean'];
  label: Scalars['String'];
  placeId?: Maybe<Scalars['String']>;
  postalCode: Scalars['String'];
  street: Scalars['String'];
};

export type SavedAddressInput = {
  apartment?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  coordinates?: InputMaybe<CoordinatesInput>;
  country: Scalars['String'];
  doorCode?: InputMaybe<Scalars['String']>;
  floor?: InputMaybe<Scalars['String']>;
  instructions?: InputMaybe<Scalars['String']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  label: Scalars['String'];
  placeId?: InputMaybe<Scalars['String']>;
  postalCode: Scalars['String'];
  street: Scalars['String'];
};

export type SendExpertiseMessageInput = {
  expertiseId: Scalars['String'];
  message: Scalars['String'];
};

export type ServiceArea = {
  __typename?: 'ServiceArea';
  allowedPostalCodes?: Maybe<Array<Scalars['String']>>;
  center?: Maybe<ServiceAreaCenter>;
  radiusKm?: Maybe<Scalars['Float']>;
};

export type ServiceAreaCenter = {
  __typename?: 'ServiceAreaCenter';
  description?: Maybe<Scalars['String']>;
  lat: Scalars['Float'];
  lng: Scalars['Float'];
  placeId?: Maybe<Scalars['String']>;
};

export type SignUpInput = {
  birthDate?: InputMaybe<Scalars['DateTime']>;
  birthFirstNames?: InputMaybe<Scalars['String']>;
  birthName?: InputMaybe<Scalars['String']>;
  birthPlace?: InputMaybe<Scalars['String']>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  callbackUrl?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  establishment?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  insuranceProvider?: InputMaybe<Scalars['String']>;
  insured?: InputMaybe<Scalars['String']>;
  insuredRelationship?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  password: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  primaryInsurance?: InputMaybe<Scalars['String']>;
  primaryPharmacy?: InputMaybe<Scalars['String']>;
  primaryPolicy?: InputMaybe<Scalars['String']>;
  secondaryInsurance?: InputMaybe<Scalars['String']>;
  secondaryPolicy?: InputMaybe<Scalars['String']>;
  secu?: InputMaybe<Scalars['String']>;
  sex?: InputMaybe<Scalars['String']>;
  surname: Scalars['String'];
};

export type SpecialityOption = {
  __typename?: 'SpecialityOption';
  _id: Scalars['String'];
  code: Scalars['String'];
  name: Scalars['String'];
  selectByDefault?: Maybe<Scalars['Boolean']>;
};

export type Staff = {
  __typename?: 'Staff';
  _id: Scalars['String'];
  active: Scalars['Boolean'];
  avatarFileId?: Maybe<Scalars['String']>;
  baudrate?: Maybe<Scalars['Float']>;
  cabinetAddresses: Array<Maybe<Address>>;
  civility?: Maybe<Civility>;
  conclusionSentences?: Maybe<Array<Scalars['String']>>;
  conflictOfInterest?: Maybe<Scalars['String']>;
  consultations: Array<Maybe<Consultation>>;
  contactInfo?: Maybe<ContactInfo>;
  contacts: Array<Contact>;
  cps: Scalars['String'];
  createdBy?: Maybe<Staff>;
  displayChat?: Maybe<Scalars['Boolean']>;
  ecgFolder?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emergencyRoom?: Maybe<Room>;
  establishment?: Maybe<Etablissement>;
  establishments?: Maybe<Array<Maybe<Etablissement>>>;
  friends?: Maybe<Array<Maybe<Staff>>>;
  friendsRequest?: Maybe<Array<Maybe<Staff>>>;
  groups?: Maybe<Array<Scalars['String']>>;
  isEmailVerified?: Maybe<Scalars['Boolean']>;
  isFirstConnection?: Maybe<Scalars['Boolean']>;
  isPhoneVerified?: Maybe<Scalars['Boolean']>;
  /** @deprecated use activeWaitingRooms instead */
  joinedWaitingRoom?: Maybe<JoinedWaitingRoom>;
  licenses: Array<Scalars['String']>;
  medconnectAgentConfig?: Maybe<MedconnectAgentConfig>;
  netsoinsId?: Maybe<Scalars['String']>;
  orders: Array<Maybe<Scalars['String']>>;
  pluginId?: Maybe<Scalars['String']>;
  policies: Array<Scalars['String']>;
  privacy?: Maybe<StaffsPrivacy>;
  roles: Array<Role>;
  showPayment?: Maybe<Scalars['Boolean']>;
  signature?: Maybe<Scalars['Buffer']>;
  slots?: Maybe<Array<TimeSlot>>;
  slug: Scalars['String'];
  speciality?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  stripe: Scalars['String'];
  stripeActivated?: Maybe<Scalars['Boolean']>;
  subscription: SubscriptionType;
  teleconsultationTraining?: Maybe<TeleconsultationTraining>;
  title?: Maybe<Scalars['String']>;
  type: KeycloakUserType;
  userInfo: UserInfo;
};

export enum StaffsPrivacy {
  Establishment = 'Establishment',
  Invisble = 'Invisble',
  Public = 'Public'
}

export enum StructureActivityCode {
  Sa01 = 'SA01',
  Sa02 = 'SA02',
  Sa03 = 'SA03',
  Sa04 = 'SA04',
  Sa05 = 'SA05',
  Sa06 = 'SA06',
  Sa07 = 'SA07',
  Sa08 = 'SA08',
  Sa09 = 'SA09',
  Sa10 = 'SA10',
  Sa11 = 'SA11',
  Sa12 = 'SA12',
  Sa13 = 'SA13',
  Sa14 = 'SA14',
  Sa15 = 'SA15',
  Sa16 = 'SA16',
  Sa17 = 'SA17',
  Sa18 = 'SA18',
  Sa19 = 'SA19',
  Sa20 = 'SA20',
  Sa21 = 'SA21',
  Sa22 = 'SA22',
  Sa23 = 'SA23',
  Sa24 = 'SA24',
  Sa25 = 'SA25',
  Sa26 = 'SA26',
  Sa27 = 'SA27',
  Sa28 = 'SA28',
  Sa29 = 'SA29',
  Sa30 = 'SA30',
  Sa31 = 'SA31',
  Sa32 = 'SA32',
  Sa33 = 'SA33',
  Sa34 = 'SA34',
  Sa35 = 'SA35',
  Sa36 = 'SA36',
  Sa37 = 'SA37',
  Sa38 = 'SA38',
  Sa39 = 'SA39',
  Sa40 = 'SA40',
  Sa41 = 'SA41',
  Sa42 = 'SA42',
  Sa43 = 'SA43',
  Sa44 = 'SA44',
  Sa45 = 'SA45',
  Sa46 = 'SA46',
  Sa47 = 'SA47',
  Sa48 = 'SA48',
  Sa49 = 'SA49',
  Sa50 = 'SA50',
  Sa51 = 'SA51',
  Sa52 = 'SA52',
  Sa53 = 'SA53',
  Sa54 = 'SA54',
  Sa55 = 'SA55',
  Sa56 = 'SA56',
  Sa57 = 'SA57',
  Sa58 = 'SA58',
  Sa59 = 'SA59',
  Sa60 = 'SA60',
  Sa61 = 'SA61'
}

export enum SubscriptionType {
  Admin = 'ADMIN',
  Custom = 'CUSTOM',
  MedAllAccess = 'MED_ALL_ACCESS',
  MedBasic = 'MED_BASIC',
  MedGuest = 'MED_GUEST',
  NoSubscription = 'NO_SUBSCRIPTION',
  PdsAllAccess = 'PDS_ALL_ACCESS',
  SuperAdmin = 'SUPER_ADMIN'
}

export type TeleconsultationTraining = {
  __typename?: 'TeleconsultationTraining';
  certifiedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  type: TrainingType;
};

export type TimeSlot = {
  __typename?: 'TimeSlot';
  consultation?: Maybe<Scalars['String']>;
  dayOfWeek: Scalars['String'];
  endTime: Scalars['String'];
  startTime: Scalars['String'];
};

export enum TrainingType {
  Dpc = 'DPC',
  Internal = 'INTERNAL',
  LearnedSociety = 'LEARNED_SOCIETY',
  None = 'NONE',
  Other = 'OTHER'
}

export type Transcription = {
  __typename?: 'Transcription';
  _id: Scalars['String'];
  audioKey?: Maybe<Scalars['String']>;
  consultation: Consultation;
  createdAt: Scalars['DateTime'];
  createdBy: Staff;
  numberRecordings?: Maybe<Scalars['Int']>;
  report?: Maybe<Report>;
  segments: Array<TranscriptionSegment>;
  updatedAt: Scalars['DateTime'];
};

export type TranscriptionSegment = {
  __typename?: 'TranscriptionSegment';
  end: Scalars['String'];
  start: Scalars['String'];
  text: Scalars['String'];
};

export type TrustedActor = {
  __typename?: 'TrustedActor';
  _id: Scalars['String'];
  addedAt: Scalars['DateTime'];
  addedBy?: Maybe<Account>;
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type UpdateConsultationStatus = {
  consultationId: Scalars['String'];
  status: ConsultationStatus;
};

export type UpdateOrderStatus = {
  formSubmission?: InputMaybe<Scalars['String']>;
  orderId: Scalars['String'];
  status: OrderStatus;
};

export type UpdatePatientDataReuseConsentInput = {
  consultationId: Scalars['String'];
  dataReuseConsent: Scalars['Boolean'];
};

export type UpdatePatientInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  agreement?: InputMaybe<Scalars['String']>;
  allergy?: InputMaybe<Scalars['String']>;
  attendingPhysician?: InputMaybe<CreateAttendingPhysicianInput>;
  background?: InputMaybe<Scalars['String']>;
  birthPlace?: InputMaybe<Scalars['String']>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  caisse?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  codeGestion?: InputMaybe<Scalars['String']>;
  codeRegime?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  cp?: InputMaybe<Scalars['String']>;
  createdBy?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  establishment?: InputMaybe<Scalars['String']>;
  files?: InputMaybe<Array<CreatePatientFileInput>>;
  gender?: InputMaybe<Gender>;
  height?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['String']>;
  imc?: InputMaybe<CreateImcInput>;
  insuranceProvider?: InputMaybe<Scalars['String']>;
  insured?: InputMaybe<Scalars['String']>;
  insuredRelationship?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  parents?: InputMaybe<Array<CreateParentInput>>;
  phone?: InputMaybe<Scalars['String']>;
  pluginId?: InputMaybe<Scalars['String']>;
  primaryInsurance?: InputMaybe<Scalars['String']>;
  primaryPharmacy?: InputMaybe<Scalars['String']>;
  primaryPolicy?: InputMaybe<Scalars['String']>;
  secondaryInsurance?: InputMaybe<Scalars['String']>;
  secondaryPolicy?: InputMaybe<Scalars['String']>;
  secu?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  surname?: InputMaybe<Scalars['String']>;
  treatment?: InputMaybe<Scalars['String']>;
  vaccins?: InputMaybe<Scalars['String']>;
  weight?: InputMaybe<Scalars['Float']>;
};

export type UpdatePatientLocationInput = {
  consultationId: Scalars['String'];
  description: Scalars['String'];
  placeId?: InputMaybe<Scalars['String']>;
};

export type UpdateSavedAddressInput = {
  addressId: Scalars['String'];
  apartment?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  coordinates?: InputMaybe<CoordinatesInput>;
  country: Scalars['String'];
  doorCode?: InputMaybe<Scalars['String']>;
  floor?: InputMaybe<Scalars['String']>;
  instructions?: InputMaybe<Scalars['String']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  label: Scalars['String'];
  placeId?: InputMaybe<Scalars['String']>;
  postalCode: Scalars['String'];
  street: Scalars['String'];
};

export type UploadFileInput = {
  filename: Scalars['String'];
  key: Scalars['String'];
  objectId: Scalars['String'];
  objectType: Scalars['String'];
};

export type UserInfo = {
  __typename?: 'UserInfo';
  birthday?: Maybe<Scalars['DateTime']>;
  gender?: Maybe<Gender>;
  language?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  notificationTimezone?: Maybe<Scalars['String']>;
  surname: Scalars['String'];
  username?: Maybe<Scalars['String']>;
};

export enum WaitingDoctorStatus {
  Available = 'AVAILABLE',
  Busy = 'BUSY',
  Offline = 'OFFLINE',
  Preparing = 'PREPARING'
}

export type WaitingRoom = {
  __typename?: 'WaitingRoom';
  _id: Scalars['String'];
  allowPatientSelection: Scalars['Boolean'];
  avgWaitingTime: Scalars['Float'];
  coPresenceConfig?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  doctors: Array<Scalars['String']>;
  establishments: Array<Scalars['String']>;
  fairDistribution?: Maybe<Scalars['String']>;
  isPrioritized: Scalars['Boolean'];
  logoUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  occupiedDoctors: Array<Scalars['String']>;
  openingHours: Array<WaitingRoomOpeningHour>;
  paymentDialogConfig?: Maybe<Scalars['String']>;
  paymentReceiverId?: Maybe<Scalars['String']>;
  price: Scalars['Float'];
  readinessConfig?: Maybe<Scalars['String']>;
  specialities: Array<SpecialityOption>;
};

export type WaitingRoomOpeningHour = {
  __typename?: 'WaitingRoomOpeningHour';
  day: Scalars['Int'];
  periods: Array<WaitingRoomPeriod>;
};

export type WaitingRoomPeriod = {
  __typename?: 'WaitingRoomPeriod';
  close: Scalars['String'];
  open: Scalars['String'];
};

export type CreateFormSubmissionMutationVariables = Exact<{
  payload: CreateFormSubmissionInput;
}>;


export type CreateFormSubmissionMutation = { __typename?: 'Mutation', createFormSubmission: { __typename?: 'FormSubmission', _id: string, status: FormSubmissionStatus, submittedAt?: any | null, tags: Array<string>, createdAt: any, updatedAt: any, template: { __typename?: 'FormTemplate', _id: string, title: string, description: string, fields: Array<{ __typename?: 'FormField', id: string, type: FormFieldType, label: string, required: boolean, options?: Array<string> | null }> }, responses: Array<{ __typename?: 'FormResponse', fieldId: string, value: any }>, submittedBy: { __typename?: 'Account', userInfo: { __typename?: 'UserInfo', name: string, surname: string } } } };

export type CreateOrderMutationVariables = Exact<{
  payload: CreateOrderInput;
}>;


export type CreateOrderMutation = { __typename?: 'Mutation', createOrder: { __typename?: 'MeetingLinkOrder', _id: string, referenceId: string, consultation?: { __typename?: 'Consultation', _id: string } | null } };

export type CreatePaymentSessionMutationVariables = Exact<{
  payload: CreatePaymentSessionInput;
}>;


export type CreatePaymentSessionMutation = { __typename?: 'Mutation', createPaymentSession: { __typename?: 'PaymentSessionResponse', sessionId: string } };

export type DeleteFilesMutationVariables = Exact<{
  payload: DeleteFilesInput;
}>;


export type DeleteFilesMutation = { __typename?: 'Mutation', deleteFiles: string };

export type DeleteOrderMutationVariables = Exact<{
  orderId: Scalars['String'];
}>;


export type DeleteOrderMutation = { __typename?: 'Mutation', deleteOrder: boolean };

export type GeneratePresignedUrlMutationVariables = Exact<{
  payload: CreatePresignedUrlInput;
}>;


export type GeneratePresignedUrlMutation = { __typename?: 'Mutation', generatePresignedUrl: string };

export type AddSavedAddressMutationVariables = Exact<{
  payload: SavedAddressInput;
}>;


export type AddSavedAddressMutation = { __typename?: 'Mutation', addSavedAddress: { __typename?: 'Patient', _id: string, savedAddresses?: Array<{ __typename?: 'SavedAddress', _id: string, label: string, street: string, city: string, postalCode: string, country: string, apartment?: string | null, floor?: string | null, doorCode?: string | null, instructions?: string | null, placeId?: string | null, isDefault: boolean, coordinates?: { __typename?: 'Coordinates', lat: number, lng: number } | null }> | null } };

export type UpdateSavedAddressMutationVariables = Exact<{
  payload: UpdateSavedAddressInput;
}>;


export type UpdateSavedAddressMutation = { __typename?: 'Mutation', updateSavedAddress: { __typename?: 'Patient', _id: string, savedAddresses?: Array<{ __typename?: 'SavedAddress', _id: string, label: string, street: string, city: string, postalCode: string, country: string, apartment?: string | null, floor?: string | null, doorCode?: string | null, instructions?: string | null, placeId?: string | null, isDefault: boolean, coordinates?: { __typename?: 'Coordinates', lat: number, lng: number } | null }> | null } };

export type DeleteSavedAddressMutationVariables = Exact<{
  addressId: Scalars['String'];
}>;


export type DeleteSavedAddressMutation = { __typename?: 'Mutation', deleteSavedAddress: { __typename?: 'Patient', _id: string, savedAddresses?: Array<{ __typename?: 'SavedAddress', _id: string, label: string, street: string, city: string, postalCode: string, country: string, apartment?: string | null, floor?: string | null, doorCode?: string | null, instructions?: string | null, placeId?: string | null, isDefault: boolean, coordinates?: { __typename?: 'Coordinates', lat: number, lng: number } | null }> | null } };

export type SendExpertiseMessageMutationVariables = Exact<{
  payload: SendExpertiseMessageInput;
}>;


export type SendExpertiseMessageMutation = { __typename?: 'Mutation', sendExpertiseMessage: { __typename?: 'ChatRoom', _id: string, messages: Array<{ __typename?: 'Message', content: string, date: any, author: { __typename?: 'Staff', _id: string, userInfo: { __typename?: 'UserInfo', name: string, surname: string } }, readBy: Array<{ __typename?: 'Staff', _id: string }> }> } };

export type SignUpMutationVariables = Exact<{
  payload: SignUpInput;
}>;


export type SignUpMutation = { __typename?: 'Mutation', signUp: string };

export type UpdateConsultationStatusMutationVariables = Exact<{
  payload: UpdateConsultationStatus;
}>;


export type UpdateConsultationStatusMutation = { __typename?: 'Mutation', updateConsultationStatus: { __typename?: 'Consultation', _id: string, status: ConsultationStatus } };

export type UpdateMyInfosMutationVariables = Exact<{
  payload: UpdatePatientInput;
}>;


export type UpdateMyInfosMutation = { __typename?: 'Mutation', updateMyInfos: { __typename?: 'Patient', _id: string, userInfo: { __typename?: 'PatientInfo', name: string, surname: string, language?: string | null } } };

export type UpdateOrderMutationVariables = Exact<{
  orderId: Scalars['String'];
  input: CreateOrderInput;
}>;


export type UpdateOrderMutation = { __typename?: 'Mutation', updateOrder: { __typename?: 'MeetingLinkOrder', _id: string, status: OrderStatus, comment?: string | null, referenceId: string, startDate: any, speciality: string, files?: Array<{ __typename?: 'MeetingLinkOrderFile', filename: string, key: string, objectType?: string | null, uploadedBy?: string | null, url?: string | null }> | null, meetingPlace: { __typename?: 'MeetingPlace', description?: string | null, placeId?: string | null } } };

export type UpdateOrderStatusMutationVariables = Exact<{
  payload: UpdateOrderStatus;
}>;


export type UpdateOrderStatusMutation = { __typename?: 'Mutation', updateOrderStatus: { __typename?: 'MeetingLinkOrder', _id: string, status: OrderStatus, formSubmission?: { __typename?: 'FormSubmission', _id: string, status: FormSubmissionStatus, submittedAt?: any | null, tags: Array<string>, createdAt: any, updatedAt: any, template: { __typename?: 'FormTemplate', _id: string, title: string, description: string, fields: Array<{ __typename?: 'FormField', id: string, type: FormFieldType, label: string, required: boolean, options?: Array<string> | null }> }, responses: Array<{ __typename?: 'FormResponse', fieldId: string, value: any }>, submittedBy: { __typename?: 'Account', userInfo: { __typename?: 'UserInfo', name: string, surname: string } } } | null } };

export type UpdatePatientDataReuseConsentMutationVariables = Exact<{
  payload: UpdatePatientDataReuseConsentInput;
}>;


export type UpdatePatientDataReuseConsentMutation = { __typename?: 'Mutation', updatePatientDataReuseConsent: { __typename?: 'Consultation', _id: string, patientConsent?: { __typename?: 'PatientConsent', recordingConsent?: boolean | null, dataReuseConsent?: boolean | null } | null } };

export type UpdatePatientLocationMutationVariables = Exact<{
  payload: UpdatePatientLocationInput;
}>;


export type UpdatePatientLocationMutation = { __typename?: 'Mutation', updatePatientLocation: { __typename?: 'Consultation', _id: string, patientLocation?: { __typename?: 'MeetingPlace', description?: string | null, placeId?: string | null } | null } };

export type UploadFileMutationVariables = Exact<{
  payload: UploadFileInput;
}>;


export type UploadFileMutation = { __typename?: 'Mutation', uploadFile: { __typename?: 'Patient', _id: string, files?: Array<{ __typename?: 'PatientFile', filename: string, key: string, objectType?: string | null, url?: string | null }> | null } };

export type GetChimeMeetingQueryVariables = Exact<{
  meetingType: Scalars['String'];
  roomOrConsultationId: Scalars['String'];
  userId: Scalars['String'];
}>;


export type GetChimeMeetingQuery = { __typename?: 'Query', chimeMeeting: { __typename?: 'ChimeMeeting', attendeeInfo: { __typename?: 'ChimeAttendeeInfo', AttendeeId: string, ExternalUserId?: string | null, JoinToken: string }, meetingInfo: { __typename?: 'ChimeMeetingInfo', MeetingId: string, MediaPlacement: { __typename?: 'ChimeMediaPlacement', AudioHostUrl?: string | null, AudioFallbackUrl?: string | null, ScreenDataUrl?: string | null, ScreenSharingUrl?: string | null, ScreenViewingUrl?: string | null, SignalingUrl?: string | null, TurnControlUrl?: string | null, EventIngestionUrl?: string | null } } } };

export type GetConsultationQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetConsultationQuery = { __typename?: 'Query', consultation: { __typename?: 'Consultation', _id: string, status: ConsultationStatus, startDate: any, speciality?: string | null, waitingRoom?: string | null, medecin?: { __typename?: 'Staff', _id: string, userInfo: { __typename?: 'UserInfo', name: string, surname: string } } | null } };

export type GetEstablishmentQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type GetEstablishmentQuery = { __typename?: 'Query', establishment: { __typename?: 'QueriedEstablishment', name: string, meetingLinks: Array<{ __typename?: 'MeetingLink', _id: string, name: string, slug: string, specialities: Array<{ __typename?: 'MeetingLinkSpeciality', code: string, name: string }> }> } };

export type GetFormTemplateQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetFormTemplateQuery = { __typename?: 'Query', formTemplate: { __typename?: 'FormTemplate', _id: string, title: string, description: string, version: number, categories: Array<string>, tags: Array<string>, isActive: boolean, createdAt: any, updatedAt: any, fields: Array<{ __typename?: 'FormField', id: string, type: FormFieldType, label: string, required: boolean, options?: Array<string> | null }> } };

export type GetActiveFormTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetActiveFormTemplatesQuery = { __typename?: 'Query', activeFormTemplates: Array<{ __typename?: 'FormTemplate', _id: string, title: string, description: string, version: number, categories: Array<string>, tags: Array<string>, isActive: boolean, createdAt: any, updatedAt: any, fields: Array<{ __typename?: 'FormField', id: string, type: FormFieldType, label: string, required: boolean, options?: Array<string> | null }> }> };

export type GetFormSubmissionQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetFormSubmissionQuery = { __typename?: 'Query', formSubmission: { __typename?: 'FormSubmission', _id: string, status: FormSubmissionStatus, submittedAt?: any | null, tags: Array<string>, createdAt: any, updatedAt: any, template: { __typename?: 'FormTemplate', _id: string, title: string, description: string, fields: Array<{ __typename?: 'FormField', id: string, type: FormFieldType, label: string, required: boolean, options?: Array<string> | null }> }, responses: Array<{ __typename?: 'FormResponse', fieldId: string, value: any }>, submittedBy: { __typename?: 'Account', userInfo: { __typename?: 'UserInfo', name: string, surname: string } } } };

export type GetPatientWaitingStatusQueryVariables = Exact<{
  consultationId: Scalars['String'];
}>;


export type GetPatientWaitingStatusQuery = { __typename?: 'Query', getPatientWaitingStatus?: { __typename?: 'PatientWaitingStatus', consultationId: string, doctorStatus: WaitingDoctorStatus, canJoin: boolean } | null };

export type GetPaymentStatusQueryVariables = Exact<{
  payload: GetPaymentStatusInput;
}>;


export type GetPaymentStatusQuery = { __typename?: 'Query', getPaymentStatus: { __typename?: 'PaymentStatusResponse', paid: boolean, sessionId?: string | null, receiptUrl?: string | null } };

export type GetMeetingLinkQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type GetMeetingLinkQuery = { __typename?: 'Query', meetingLink: { __typename?: 'MeetingLink', _id: string, description?: string | null, name: string, availabilities: Array<{ __typename?: 'MeetingLinkAvailability', _id: string, additionalAddress?: string | null, avgMeetingDuration: number, isRecurrence: boolean, meetingPlace: AvailabilityMeetingPlace, notes: string, specialities: Array<string>, address?: { __typename?: 'MeetingLinkAvailabilityAddress', description: string, placeId: string } | null, formTemplate?: { __typename?: 'FormTemplate', _id: string, title: string, description: string, isActive: boolean, fields: Array<{ __typename?: 'FormField', id: string, type: FormFieldType, label: string, required: boolean, options?: Array<string> | null }> } | null, recurrenceDays: Array<{ __typename?: 'MeetingLinkAvailabilityRecurrenceDay', day: number, timeZone: string, periods: Array<{ __typename?: 'MeetingLinkAvailabilityPeriod', open: number, close: number }> }>, scheduledDays: Array<{ __typename?: 'MeetingLinkAvailabilityScheduledDay', day: string, format: string, timeZone: string, periods: Array<{ __typename?: 'MeetingLinkAvailabilityPeriod', open: number, close: number }> }>, unavailabilities?: Array<{ __typename?: 'MeetingLinkUnavailability', _id: string, startDate: any, endDate: any, startTime?: number | null, endTime?: number | null }> | null, paymentConfig?: { __typename?: 'MeetingLinkAvailabilityPaymentConfig', requiresPayment?: boolean | null, basePrice?: number | null, paymentReceiver?: { __typename?: 'PublicStaffPaymentConfig', _id: string, stripe: string, stripeActivated: boolean, userInfo: { __typename?: 'PublicStaffPaymentConfigUserInfo', name: string, surname: string } } | null, priceModifiers?: Array<{ __typename?: 'MeetingLinkAvailabilityPriceModifier', meetingPlace: AvailabilityMeetingPlace, modifier: number }> | null } | null, serviceArea?: { __typename?: 'ServiceArea', allowedPostalCodes?: Array<string> | null, radiusKm?: number | null, center?: { __typename?: 'ServiceAreaCenter', description?: string | null, placeId?: string | null, lat: number, lng: number } | null } | null }>, busySlots: Array<{ __typename?: 'MeetingLinkBusySlot', start: any, end: any }>, createdBy: { __typename?: 'Staff', _id: string, slug: string, establishment?: { __typename?: 'Etablissement', name: string, slug: string } | null, userInfo: { __typename?: 'UserInfo', name: string, surname: string } }, specialities: Array<{ __typename?: 'MeetingLinkSpeciality', code: string, name: string, price: number }>, staffs: Array<{ __typename?: 'Staff', _id: string, status: string, stripe: string, stripeActivated?: boolean | null, userInfo: { __typename?: 'UserInfo', name: string, surname: string } }>, immediateConsultationConfig?: { __typename?: 'ImmediateConsultationConfig', enabled: boolean, maxWaitingPatients?: number | null, requirePaymentUpfront: boolean, price?: number | null, paymentReceiver?: { __typename?: 'Staff', _id: string, stripe: string, stripeActivated?: boolean | null, userInfo: { __typename?: 'UserInfo', name: string, surname: string } } | null } | null, waitingRoom?: { __typename?: 'WaitingRoom', _id: string, name: string, avgWaitingTime: number } | null } };

export type SearchMeetingLinksQueryVariables = Exact<{
  phrase: Scalars['String'];
}>;


export type SearchMeetingLinksQuery = { __typename?: 'Query', meetingLinksSearch: Array<{ __typename: 'Etablissement', _id: string, name: string, slug: string } | { __typename: 'MeetingLink', _id: string, name: string, slug: string, specialities: Array<{ __typename?: 'MeetingLinkSpeciality', code: string, name: string }> }> };

export type GetMyInfosQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyInfosQuery = { __typename?: 'Query', myInfos: { __typename?: 'Patient', _id: string, agreement: string, isProfileComplete?: boolean | null, isConsultationReady?: boolean | null, email?: string | null, secu: string, insNIR?: string | null, insOID?: string | null, insured?: string | null, insuredRelationship?: string | null, insuranceProvider?: string | null, primaryInsurance?: string | null, secondaryInsurance?: string | null, primaryPolicy?: string | null, secondaryPolicy?: string | null, primaryPharmacy?: string | null, consultations: Array<{ __typename?: 'Consultation', _id: string, autoRecording?: boolean | null, recordingConsentPending?: boolean | null, commentaire?: string | null, endDate?: any | null, paid?: boolean | null, startDate: any, status: ConsultationStatus, type: ConsultationType, waitingRoom?: string | null, biologicals?: Array<{ __typename?: 'Biological', id: string }> | null, createdBy: { __typename?: 'Staff', userInfo: { __typename?: 'UserInfo', name: string, surname: string } }, establishment?: { __typename?: 'Etablissement', _id: string, name: string } | null, files: Array<{ __typename?: 'ConsultationFile', filename: string, key: string, url?: string | null }>, medecin?: { __typename?: 'Staff', _id: string, civility?: Civility | null, title?: string | null, speciality?: string | null, userInfo: { __typename?: 'UserInfo', gender?: Gender | null, name: string, surname: string }, teleconsultationTraining?: { __typename?: 'TeleconsultationTraining', type: TrainingType, description?: string | null } | null, cabinetAddresses: Array<{ __typename?: 'Address', description: string } | null> } | null, pds?: { __typename?: 'Staff', _id: string, userInfo: { __typename?: 'UserInfo', name: string, surname: string, gender?: Gender | null } } | null, mesures: Array<{ __typename?: 'ConsultationMesure', label: string, order: number, unit: string, value?: string | null }>, patientConsent?: { __typename?: 'PatientConsent', recordingConsent?: boolean | null } | null, patientLocation?: { __typename?: 'MeetingPlace', description?: string | null, placeId?: string | null } | null }>, establishment?: { __typename?: 'Etablissement', _id: string, name: string } | null, files?: Array<{ __typename?: 'PatientFile', filename: string, key: string, url?: string | null }> | null, userInfo: { __typename?: 'PatientInfo', birthday?: any | null, gender?: Gender | null, name: string, surname: string, language?: string | null, birthName?: string | null, birthFirstName?: string | null, birthSurname?: string | null, birthPlace?: string | null, birthPlaceCode?: string | null }, orders: Array<{ __typename?: 'MeetingLinkOrder', _id: string, speciality: string, referenceId: string, startDate: any, status: OrderStatus, acceptedBy?: { __typename?: 'Staff', userInfo: { __typename?: 'UserInfo', gender?: Gender | null, name: string, surname: string } } | null, meetingPlace: { __typename?: 'MeetingPlace', description?: string | null, placeId?: string | null, apartment?: string | null, floor?: string | null, doorCode?: string | null, instructions?: string | null, postalCode?: string | null }, meetingLink?: { __typename?: 'MeetingLink', _id: string, description?: string | null, isPrioritized?: boolean | null, name: string, specialities: Array<{ __typename?: 'MeetingLinkSpeciality', name: string, price: number }>, staffs: Array<{ __typename?: 'Staff', userInfo: { __typename?: 'UserInfo', name: string } }> } | null, files?: Array<{ __typename?: 'MeetingLinkOrderFile', url?: string | null, key: string, filename: string }> | null, formSubmission?: { __typename?: 'FormSubmission', _id: string, status: FormSubmissionStatus, submittedAt?: any | null, tags: Array<string>, createdAt: any, updatedAt: any, template: { __typename?: 'FormTemplate', _id: string, title: string, description: string, fields: Array<{ __typename?: 'FormField', id: string, type: FormFieldType, label: string, required: boolean, options?: Array<string> | null }> }, responses: Array<{ __typename?: 'FormResponse', fieldId: string, value: any }>, submittedBy: { __typename?: 'Account', userInfo: { __typename?: 'UserInfo', name: string, surname: string } } } | null }>, contactInfo?: { __typename?: 'ContactInfo', phone?: string | null, cp?: number | null, city?: string | null, street?: string | null, country?: string | null } | null, savedAddresses?: Array<{ __typename?: 'SavedAddress', _id: string, label: string, street: string, city: string, postalCode: string, country: string, apartment?: string | null, floor?: string | null, doorCode?: string | null, instructions?: string | null, placeId?: string | null, isDefault: boolean, coordinates?: { __typename?: 'Coordinates', lat: number, lng: number } | null }> | null, attendingPhysician?: { __typename?: 'AttendingPhysician', firstname: string, lastname: string, gender?: string | null, email?: string | null, phone?: string | null } | null, parents?: Array<{ __typename?: 'Parent', _id: string, city?: string | null, cp?: number | null, email?: string | null, firstname: string, lastname: string, phone?: string | null, street?: string | null }> | null, events: Array<{ __typename?: 'Event', _id: string, createdAt?: any | null, object_id: string, object_type: EventObjectType, channels: Array<Channel>, type: EventType, recipients: Array<{ __typename?: 'Recipient', userId: string, type: RecipientType, read?: boolean | null }> }>, expertises: Array<{ __typename?: 'Expertise', _id: string, status: ExpertiseStatus, startDate: any, endDate?: any | null, speciality?: string | null, conclusion?: string | null, diagnostic?: string | null, comment?: string | null, consultations?: Array<{ __typename?: 'Consultation', _id: string, startDate: any, status: ConsultationStatus, speciality?: string | null }> | null, files: Array<{ __typename?: 'ExpertiseFile', filename: string, key: string, objectType?: string | null, url?: string | null }>, chatRoom?: { __typename?: 'ChatRoom', _id: string, messages: Array<{ __typename?: 'Message', content: string, date: any, author: { __typename?: 'Staff', _id: string, userInfo: { __typename?: 'UserInfo', name: string, surname: string } }, readBy: Array<{ __typename?: 'Staff', _id: string }> }> } | null, medecin?: { __typename?: 'Staff', _id: string, speciality?: string | null, userInfo: { __typename?: 'UserInfo', name: string, surname: string } } | null, createdBy?: { __typename?: 'Staff', _id: string, speciality?: string | null, status: string, userInfo: { __typename?: 'UserInfo', name: string, surname: string } } | null, patient: { __typename?: 'Patient', _id: string }, formSubmissions?: Array<{ __typename?: 'FormSubmission', _id: string, status: FormSubmissionStatus, tags: Array<string>, submittedAt?: any | null, createdAt: any, updatedAt: any, template: { __typename?: 'FormTemplate', _id: string, title: string, description: string, version: number, fields: Array<{ __typename?: 'FormField', id: string, type: FormFieldType, label: string, required: boolean, options?: Array<string> | null }> }, responses: Array<{ __typename?: 'FormResponse', fieldId: string, value: any }>, submittedBy: { __typename?: 'Account', userInfo: { __typename?: 'UserInfo', name: string, surname: string } } }> | null }>, formSubmissions: Array<{ __typename?: 'FormSubmission', _id: string, status: FormSubmissionStatus, ethicsResponse?: string | null, respondedAt?: any | null, tags: Array<string>, submittedAt?: any | null, createdAt: any, updatedAt: any, template: { __typename?: 'FormTemplate', _id: string, title: string, description: string, version: number, categories: Array<string>, tags: Array<string>, fields: Array<{ __typename?: 'FormField', id: string, type: FormFieldType, label: string, required: boolean, options?: Array<string> | null }> }, patient: { __typename?: 'Patient', _id: string }, consultation?: { __typename?: 'Consultation', _id: string, startDate: any, status: ConsultationStatus } | null, expertise?: { __typename?: 'Expertise', _id: string, startDate: any, status: ExpertiseStatus } | null, responses: Array<{ __typename?: 'FormResponse', fieldId: string, value: any }>, submittedBy: { __typename?: 'Account', userInfo: { __typename?: 'UserInfo', name: string, surname: string } }, respondedBy?: { __typename?: 'Account', userInfo: { __typename?: 'UserInfo', name: string, surname: string } } | null }> } };

export type GetOrderQueryVariables = Exact<{
  orderId: Scalars['String'];
}>;


export type GetOrderQuery = { __typename?: 'Query', meetingLinkOrder: { __typename?: 'MeetingLinkOrder', _id: string, referenceId: string, speciality: string, startDate: any, status: OrderStatus, meetingPlace: { __typename?: 'MeetingPlace', description?: string | null }, files?: Array<{ __typename?: 'MeetingLinkOrderFile', filename: string, key: string, url?: string | null }> | null, consultation?: { __typename?: 'Consultation', _id: string } | null } };

export type GetPatientFilesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPatientFilesQuery = { __typename?: 'Query', myInfos: { __typename?: 'Patient', _id: string, consultations: Array<{ __typename?: 'Consultation', endDate?: any | null, startDate: any, status: ConsultationStatus, _id: string, files: Array<{ __typename?: 'ConsultationFile', filename: string, key: string, url?: string | null }> }>, files?: Array<{ __typename?: 'PatientFile', filename: string, key: string, url?: string | null }> | null } };

export type ListPrioritizedMeetingLinksQueryVariables = Exact<{ [key: string]: never; }>;


export type ListPrioritizedMeetingLinksQuery = { __typename?: 'Query', prioritizedMeetingLinks: Array<{ __typename?: 'MeetingLink', _id: string, description?: string | null, name: string, slug: string, availabilities: Array<{ __typename?: 'MeetingLinkAvailability', _id: string, address?: { __typename?: 'MeetingLinkAvailabilityAddress', description: string, placeId: string } | null }>, specialities: Array<{ __typename?: 'MeetingLinkSpeciality', code: string, name: string }> }> };

export type GetTrackedOrderQueryVariables = Exact<{
  referenceId: Scalars['String'];
}>;


export type GetTrackedOrderQuery = { __typename?: 'Query', trackedOrder: { __typename?: 'MeetingLinkOrder', _id: string, referenceId: string, speciality: string, startDate: any, status: OrderStatus, meetingPlace: { __typename?: 'MeetingPlace', description?: string | null }, createdBy: { __typename?: 'Patient', email?: string | null, contactInfo?: { __typename?: 'ContactInfo', phone?: string | null } | null, userInfo: { __typename?: 'PatientInfo', name: string, surname: string } }, consultation?: { __typename?: 'Consultation', _id: string } | null, files?: Array<{ __typename?: 'MeetingLinkOrderFile', filename: string, key: string, url?: string | null }> | null, meetingLink?: { __typename?: 'MeetingLink', _id: string, name: string } | null, acceptedBy?: { __typename?: 'Staff', speciality?: string | null, userInfo: { __typename?: 'UserInfo', gender?: Gender | null, name: string, surname: string } } | null } };
